const amount = value => Number.isFinite(Number(value)) ? Number(value) : 0;
const stable = value => {
  if (Array.isArray(value)) return value.map(stable);
  if (value && typeof value === 'object') return Object.keys(value).sort().reduce((result, key) => ({ ...result, [key]: stable(value[key]) }), {});
  return value ?? null;
};

export function orbitGroupKey(item) {
  const custom = Boolean(item.isCustomItem || item.isCustom || item.isManualPrice || item.manualPrice);
  return JSON.stringify(stable({
    productId: item.productId, skuId: item.skuId, condition: item.condition,
    printing: item.printing, language: item.language, isCash: item.isCash,
    orderNote: item.orderNote || '', nonEnglish: item.nonEnglish,
    categoryId: item.categoryId, sealed: item.isSealed,
    fallback: !item.productId || !item.skuId ? [item.name, item.set, item.number] : null,
    custom: custom ? { id: item.id, customItemId: item.customItemId, name: item.name,
      cashPrice: item.cashPrice, creditPrice: item.creditPrice, isCustomItem: item.isCustomItem,
      isCustom: item.isCustom, isManualPrice: item.isManualPrice, manualPrice: item.manualPrice } : null,
  }));
}

export function groupOrbitCart(items = []) {
  const groups = new Map();
  items.forEach(item => {
    const key = orbitGroupKey(item);
    if (!groups.has(key)) groups.set(key, { key, item, items: [], cashTotal: 0, creditTotal: 0, selectedTotal: 0 });
    const group = groups.get(key);
    group.items.push(item);
    group.cashTotal += amount(item.cashPrice);
    group.creditTotal += amount(item.creditPrice);
    group.selectedTotal += amount(item.isCash ? item.cashPrice : item.creditPrice);
  });
  return [...groups.values()];
}

// Reference membership avoids deleting another copy if legacy cart IDs collide.
export function removeOrbitCopies(current, copies) {
  const remaining = [...copies];
  return current.filter(item => {
    const index = remaining.indexOf(item);
    if (index < 0) return true;
    remaining.splice(index, 1);
    return false;
  });
}

export function incrementOrbitGroup(group, addToCart, isCash) {
  const item = group.item;
  return addToCart(item, item.condition, item.printing, 1, item.skuId, isCash, item.language || 'EN', item.orderNote || '', item.nonEnglish ?? null);
}
